import * as React from "react";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { slugify } from "@grandvisionhq/utils";
import StoreOverview from "./StoreOverview.js";
const StoreOverviewContainer = ({
  store,
  googleMapsApiKey,
  storesUrl,
  ...rest
}) => {
  const { getLabel } = useIntl();
  const { isStoreDetailsEmailEnabled, isStoreDetailsPhoneEnabled } = useFeatureToggles();
  const labels = React.useMemo(
    () => ({
      storeDetailLink: getLabel("appointments.component.storeOverview.storeDetailLink")
    }),
    [getLabel]
  );
  const {
    additionalStreetInfo,
    streetName,
    streetNumber,
    postalCode,
    town,
    province,
    country,
    name,
    lat,
    lon,
    phone,
    email,
    slug
  } = store;
  const addressData = React.useMemo(
    () => ({
      storeName: name,
      additionalStreetInfo: additionalStreetInfo ?? "",
      streetName,
      streetNumber: streetNumber ?? "",
      postalCode: postalCode ?? "",
      town,
      province: province ?? "",
      country
    }),
    [name, additionalStreetInfo, streetName, streetNumber, postalCode, town, province, country]
  );
  const mapImageUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lon}&zoom=13&size=640x200&scale=2&markers=anchor:28,48|icon:https://assets.grandvision.io/global/store2.png|scale:2%7C${lat},${lon}&mapType=roadmap&key=${googleMapsApiKey}`;
  const storeDetailLink = `${storesUrl}/${slugify(town)}/${slug}`;
  return /* @__PURE__ */ React.createElement(
    StoreOverview,
    {
      ...rest,
      labels,
      addressData,
      mapImageUrl,
      storeDetailLink,
      phoneHidden: !isStoreDetailsPhoneEnabled,
      emailHidden: !isStoreDetailsEmailEnabled,
      phone,
      email
    }
  );
};
export {
  StoreOverviewContainer as default
};
//# sourceMappingURL=StoreOverviewContainer.js.map
